/* eslint-disable import/max-dependencies */
/* eslint-disable max-lines-per-function */
import React, { useEffect, useState } from "react";
import { Grid } from "@material-ui/core";
import { debounce } from "lodash";
import { InputText } from "@loanbossinc/component-library";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { PaddedWrapper } from "../styles";
import { actionCreators as newLineItemActionCreators } from "../lineItemManagement.store";
import { actionCreators as drawerAcitonCreators } from "../../lenderReportingDrawer.store";
import { actionCreators as fieldActionCreators } from "../../field-management/fieldManagement.store";

import FieldListItem from "./FieldListItem";
import { Container, StyledSecondaryButton, StyledSearchHeader, ButtonWrapper } from "./styles";
import { filterNonMonetaryFields, excludeByNoiType } from "./util";

const FormulaFields = props => {
  const {
    fields,
    deal,
    getFields,
    selectedField,
    isMultipleProperties,
    newLineItemType,
    activeCardIndex,
    singlePropertyComparisonCards,
    setDrawerSelections,
    setFieldSelections,
    setNewLineItemSelections,
    multiplePropertiesValueFields,
    propertyIdSelected,
    multiplePropertiesComparisonFields,
    multiPropComparisonSubLineItemNames,
    accountingIntegrations,
    addLineItemType,
    selectedReportGroup,
    adjustedExpenseLineItems,
    adjustedIncomeLineItems
  } = props;

  const [filteredFields, setFilteredFields] = useState(null);

  useEffect(() => {
    if (deal) {
      getFields({ dealId: deal.id });
    }
  }, []);

  useEffect(() => {
    // logic of excluding fields that have been already selected
    if (newLineItemType === "comparison") {
      if (!isMultipleProperties) {
        const selectedFieldsIds = singlePropertyComparisonCards.map(card => card.selectedField && card.selectedField.id);
        const filtered = fields?.filter(field => !selectedFieldsIds.includes(field.id));
        const monetaryFields = filterNonMonetaryFields(filtered);
        const excludedNoiFields = excludeByNoiType(monetaryFields, addLineItemType, selectedReportGroup.id, adjustedExpenseLineItems, adjustedIncomeLineItems);
        setFilteredFields(excludedNoiFields);
      } else {
        const fieldIdsToExclude = [];
        for (const propField of multiplePropertiesComparisonFields) {
          const selectedProp = propField.find(prop => prop.propertyId === propertyIdSelected);
          if (selectedProp && selectedProp.selectedField) {
            fieldIdsToExclude.push(selectedProp.selectedField.id);
          }
        }
        const fieldsWithSelectedExcluded = fields?.filter(field => !fieldIdsToExclude.includes(field.id));
        const monetaryFieldsWithSelectedExcluded = filterNonMonetaryFields(fieldsWithSelectedExcluded);
        const excludedNoiFieldsWithSelectedExcluded = excludeByNoiType(
          monetaryFieldsWithSelectedExcluded,
          addLineItemType,
          selectedReportGroup.id,
          adjustedExpenseLineItems,
          adjustedIncomeLineItems
        );
        setFilteredFields(excludedNoiFieldsWithSelectedExcluded);
      }
    } else {
      const monetaryFields = filterNonMonetaryFields(fields);
      const excludedNoiFields = excludeByNoiType(monetaryFields, addLineItemType, selectedReportGroup.id, adjustedExpenseLineItems, adjustedIncomeLineItems);
      setFilteredFields(excludedNoiFields);
    }
  }, [fields, newLineItemType, isMultipleProperties, singlePropertyComparisonCards, multiplePropertiesComparisonFields, propertyIdSelected]);

  const getFilteredFieldsByName = searchTerm => filterNonMonetaryFields(fields).filter(field => field && field.name && field.name.toLowerCase().includes(searchTerm));

  const handleSearchByName = e => {
    e.persist();

    const debounceDelay = 500;
    const handleSearchDebounce = debounce(event => {
      if (event.target.value) {
        const filtered = getFilteredFieldsByName(event.target.value.toLowerCase());
        setFilteredFields(filtered);
      } else {
        const monetaryFields = filterNonMonetaryFields(fields);
        setFilteredFields(monetaryFields);
      }
    }, debounceDelay);

    handleSearchDebounce(e);
  };

  const onAddNewHandler = () => {
    setDrawerSelections({ currentSectionName: "field-management", isFromLineItemManagement: true });
    setFieldSelections({ isAdding: true, isFromAddNewLineItem: true });
  };

  const onSelectedField = field => {
    if (isMultipleProperties) {
      const fieldMappingFunc = property => {
        if (property.propertyId === propertyIdSelected) {
          return { ...property, selectedField: field };
        }

        return property;
      };

      if (newLineItemType === "value") {
        const updatedMultipleValueFields = multiplePropertiesValueFields.map(fieldMappingFunc);
        setNewLineItemSelections({ multiplePropertiesValueFields: updatedMultipleValueFields, newLineItemName: field.name });
        setDrawerSelections({ currentSectionName: "line-item-management" });
      } else {
        const updatedComparisonFields = multiplePropertiesComparisonFields.map((group, idx) => {
          if (idx === activeCardIndex) {
            return group.map(fieldMappingFunc);
          }

          return group;
        });
        const updatedSubgroupNames = multiPropComparisonSubLineItemNames.map((subgroupName, idx) => {
          if (idx === activeCardIndex) {
            return subgroupName || field.name;
          }

          return subgroupName;
        });

        setNewLineItemSelections({
          multiplePropertiesComparisonFields: updatedComparisonFields,
          multiPropComparisonSubLineItemNames: updatedSubgroupNames
        });
        setDrawerSelections({ currentSectionName: "line-item-management" });
      }
    } else if (newLineItemType === "value") {
      setNewLineItemSelections({ selectedField: field, newLineItemName: field.name });
    } else {
      const updatedComparisonCards = singlePropertyComparisonCards.map((card, index) => {
        if (index === activeCardIndex) {
          return { ...card, selectedField: field, name: card.name || field.name };
        }

        return card;
      });

      setNewLineItemSelections({ singlePropertyComparisonCards: updatedComparisonCards });
      setDrawerSelections({ currentSectionName: "line-item-management" });
    }
  };

  return (
    <Container>
      <StyledSearchHeader>
        <Grid container alignItems="center">
          <Grid item xs={9}>
            <PaddedWrapper>
              <InputText
                onChange={handleSearchByName}
                variant="filled"
                id="search-field-by-name"
                name="search-field-by-name"
                label="Search fields by name"
                fullWidth
              />
            </PaddedWrapper>
          </Grid>
          <Grid item xs={3}>
            <ButtonWrapper>
              <StyledSecondaryButton label="Add new" onClick={onAddNewHandler} />
            </ButtonWrapper>
          </Grid>
        </Grid>
      </StyledSearchHeader>
      {filteredFields &&
        filteredFields.map(field => (
          <FieldListItem
            field={field}
            key={field.id}
            onSelectedField={onSelectedField}
            isSelected={field?.id === selectedField?.id && newLineItemType === "value"}
            accountingIntegrations={accountingIntegrations}
            propertyIdSelected={propertyIdSelected}
          />
        ))}
    </Container>
  );
};

const mapStateToProps = ({
  lenderReportFieldManagement: { fields },
  lenderReportNewLineItemManagement,
  lenderReportingNoiCalculation: { addLineItemType, adjustedExpenseLineItems, adjustedIncomeLineItems },
  lenderReportList: { selectedReportGroup }
}) => ({ ...lenderReportNewLineItemManagement, fields, addLineItemType, adjustedExpenseLineItems, adjustedIncomeLineItems, selectedReportGroup });

const mapDispatchToProps = dispatch => bindActionCreators({ ...drawerAcitonCreators, ...newLineItemActionCreators, ...fieldActionCreators }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(FormulaFields);
